import React from "react";

import * as FormControl from "lib/components/FormControl";
import OrderBillItem from "./OrderBillItem";

export default class OrderedItemOrderBillItem extends React.PureComponent {
  handlePropChange(prop, value, autoCalculateOtherProp = true) {
    const { orderedItem, onChange } = this.props;

    if (prop === "quantity") {
      const quantity = value;
      const min_persons_count = quantity * (orderedItem.product_pricelist_item.min_persons_count || 0);
      const max_persons_count = quantity * (orderedItem.product_pricelist_item.max_persons_count || Infinity);
      let persons_count = orderedItem.persons_count;
      if (autoCalculateOtherProp) {
        persons_count = Math.min(max_persons_count, Math.max(min_persons_count, orderedItem.persons_count));
      }
      onChange({
        ...orderedItem,
        quantity,
        persons_count,
      });
    } else if (prop === "persons_count") {
      const persons_count = value;
      const min_quantity =
        orderedItem.product_pricelist_item.min_persons_count > 0
          ? Math.floor(persons_count / orderedItem.product_pricelist_item.min_persons_count)
          : 0;
      const max_quantity =
        orderedItem.product_pricelist_item.max_persons_count < Infinity
          ? Math.ceil(persons_count / orderedItem.product_pricelist_item.max_persons_count)
          : Infinity;
      let quantity = orderedItem.quantity;
      if (autoCalculateOtherProp) {
        quantity = Math.min(max_quantity, Math.max(min_quantity, orderedItem.quantity));
      }
      if (orderedItem.product_pricelist_item.pricelist_type === "pricelist_by_order") {
        quantity = 1;
      }
      onChange({
        ...orderedItem,
        quantity,
        persons_count,
      });
    }
  }

  render() {
    const { orderedItem, name, errors, onFocus, onBlur } = this.props;
    const item = orderedItem.product_pricelist_item;
    const showQuantityInput = item.pricelist_type !== "pricelist_by_person";
    const showPersonsCountInput = item.min_persons_count !== null || item.max_persons_count !== null;
    const isQuantityEditable = showQuantityInput && item.pricelist_type !== "pricelist_by_order";

    if (showQuantityInput && showPersonsCountInput) {
      const showPrice = !(item.pricelist_type === "pricelist_by_order" && orderedItem.total_price.value === 0);
      return (
        <div>
          <OrderBillItem
            key="quantity"
            {...FormControl.addProps(`${name}.quantity`, { errors })}
            itemName={item.display_name}
            itemQuantity={orderedItem.quantity}
            itemQuantityMin={0}
            itemQuantityEditable={isQuantityEditable}
            itemUnitPrice={showPrice && (isQuantityEditable ? orderedItem.unit_price : undefined)}
            itemUnitPriceLabel={showPrice && (isQuantityEditable ? item.price_label : undefined)}
            itemTotalPrice={showPrice && orderedItem.total_price}
            controlType="number"
            onChange={(_, v) => this.handlePropChange("quantity", v, true)}
            onFocus={onFocus}
            onBlur={onBlur}
          />
          <OrderBillItem
            key="persons_count"
            {...FormControl.addProps(`${name}.persons_count`, { errors })}
            itemName={
              <span>
                <i className="icon material-icons">people</i>{" "}
                {I18n.humanAttributeName("product_pricelist_item", "persons_count")}
                {item.pricelist_type !== "pricelist_by_order" && <span> ({item.display_name})</span>}
              </span>
            }
            itemQuantity={orderedItem.persons_count}
            itemQuantityMin={item.pricelist_type === "pricelist_by_order" ? orderedItem.min_persons_count : 0}
            itemQuantityMax={item.pricelist_type === "pricelist_by_order" ? orderedItem.max_persons_count : undefined}
            itemQuantityEditable
            controlType="number"
            onChange={(_, v) => this.handlePropChange("persons_count", v, true)}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </div>
      );
    } else {
      const prop = showQuantityInput ? "quantity" : "persons_count";
      return (
        <OrderBillItem
          key={prop}
          {...FormControl.addProps(`${name}`, { errors })}
          itemName={item.display_name}
          itemQuantity={orderedItem[prop]}
          itemQuantityMin={0}
          itemQuantityEditable={prop === "quantity" ? isQuantityEditable : true}
          itemUnitPrice={prop !== "quantity" || isQuantityEditable ? orderedItem.unit_price : undefined}
          itemUnitPriceLabel={prop !== "quantity" || isQuantityEditable ? item.price_label : undefined}
          itemTotalPrice={orderedItem.total_price}
          controlType="number"
          onChange={(_, v) => this.handlePropChange(prop, v, true)}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/NewOrderModal/NewOrderItemsForm/OrderedItemOrderBillItem.jsx